module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    staticClass: "modal-fade",
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "reengagement-report",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('i', {
      staticClass: "fa fa-bar-chart report-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.title) + "\n            "), _c('div', {
      staticClass: "closeButton"
    })]
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "reengagement-report-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-md-6 mb-4"
  }, [_c('div', {
    staticClass: "card border-left-green shadow py-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row no-gutters align-items-center"
  }, [_c('div', {
    staticClass: "col mr-2"
  }, [_c('div', {
    staticClass: "text-sm font-weight-bold text-green text-uppercase mb-1"
  }, [_vm._v("\n                                    Estimated Audience*")]), _vm._v(" "), _c('div', {
    staticClass: "heading-style text-lg mb-0 font-weight-bold text-gray-800"
  }, [_vm._v(_vm._s(_vm.reengagementReport.estimatedAudienceCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign fa-2x text-gray-300"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-red"
  }, [_vm._v("*Some users may be excluded at reengagement runtime.")]), _vm._v(" "), _c('div', {
    staticClass: "campaign-details margin-top-20"
  }, [_c('div', [_vm._v("Reengagement Name: "), _c('span', {
    staticClass: "campaign-details-text"
  }, [_vm._v(_vm._s(this.campaignDetails.campaign_name ? this.campaignDetails.campaign_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Country: "), _c('span', {
    staticClass: "campaign-details-text"
  }, [_vm._v(_vm._s(this.campaignDetails.country ? this.campaignDetails.country : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Type: "), _c('span', {
    staticClass: "campaign-details-text"
  }, [_vm._v(_vm._s(this.campaignDetails.campaign_type ? this.campaignDetails.campaign_type : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Audience: "), _c('span', {
    staticClass: "campaign-details-text"
  }, [_vm._v(_vm._s(this.campaignDetails.audience_name ? this.campaignDetails.audience_name : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "campaign-group-details"
  }, _vm._l((this.campaignDetails.group_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "campaign-group-container border-left-rose"
    }, [_c('div', [_vm._v("Group Name: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.group_name ? item.group_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Nudge: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.msg_template_name ? item.msg_template_name : '-'))])]), _vm._v(" "), (item.conversation) ? _c('div', [_vm._v("Conversation: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.conversation ? item.conversation : '-'))])]) : _c('div', [_vm._v("Keyword: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.keyword ? item.keyword : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Destination: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.destination_app_name ? item.destination_app_name : '-'))])]), _vm._v(" "), _c('div', [_vm._v("Split Percent: "), _c('span', {
      staticClass: "campaign-details-text"
    }, [_vm._v(_vm._s(item.split_percent || item.split_percent === 0 ? item.split_percent + '%' : '-'))])])])
  }), 0)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v("Close")])]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3f983488","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reengagement-manager/scheduledReport.vue
// module id = twUZ
// module chunks = 1